import React from 'react';
import TableShowData from '@/pages/intelligence/components/TableComponents/components/TableShowData';
import CloumsCenter from '@/pages/intelligence/components/TableComponents/components/CloumsCenter';
import TabComponents from '@/pages/intelligence/components/TabComponents';
import { IMetricList } from '@/pages/intelligence/pages/GenreProfile/typings';
import { valueFormat } from '@/pages/intelligence/utils/commonUtils';

export default function MetricColContent(props) {
  const { metricName, config, context, keyMap, ratioHideCol = [], textBubble } = props;

  const { valueType, align, childWidth = 170, childAlign = 'right' } = config;
  const value = context[metricName];
  const ratio = context[`${metricName}_growth`];

  // valueType为hashMark，环比值为整数
  const getGrowth = (value: number) => {
    if (!value) return '-';
    if (valueType === 'hashMark') return value?.toString();
    if (value === -1 || value === 1) return '100%';
    const _value = Math.abs(value * 100);
    if (_value > 9999) return '9999+%';
    return `${_value.toString().includes('.') ? _value.toFixed(2) : _value}%`;
  };

  const getType = (value: number | string) => {
    if (!value) return '';
    if (value === '-' || value === '=') return '';
    return Number(value) > 0 ? 'up' : 'down';
  };

  const getDodHide = (str: string) => {
    return ratioHideCol?.includes(str);
  };

  // valueType为hashMark，值要加#
  const getValue = (value: string) => {
    if (!valueType || valueType === 'normal') return valueFormat(value);
    if (valueType === 'hashMark') return !value ? '-' : `#${value}`;
    return valueFormat(value);
  };

  const getElContent = () => {
    return (
      <TableShowData
        value={getValue(value)}
        type={getType(ratio)}
        growth={getGrowth(ratio)}
        isDodHide={getDodHide(metricName)}
        maxNumber={'99999+%'}
      />
    );
  };

  return (
    <div className="dbi-insights-table-flex" key={metricName}>
      {align === 'center' ? (
        <CloumsCenter
          width={childWidth}
          // style={{ marginLeft: '-40px' }}
          align={childAlign}
        >
          {getElContent()}
        </CloumsCenter>
      ) : (
        getElContent()
      )}
      {textBubble?.text ? <TabComponents data={textBubble} /> : ''}
    </div>
  );
}
